import Vue from 'vue'
import moment from 'moment'

// Central data store
// Store.js
export default new Vue ({
	data: {
		apiRoot: window.apiRoot,
		GoogleEmbedAPIkey: "AIzaSyDhErESj8MScusckXehTmbU5Ncc1zNzgSI",
		TinyMCEAPIKey: "dzvecmwzbkn7dd8gignz7bsl6g9pqzfjn89bhfbtaelncdxl",
		pushPublicKey: "BKCUYrW4Yvx_74FoeyAkQvA75-nV1PXEiR-YBywXlt5jR-Hf-ntU46p6dV09Dw-dwIgKjSG7PDpTLF2CeJeFIA8",
		//pushPrivateKey: "", //remove in prod
		demoLink: "https://meetings.hubspot.com/c-renaud1?uuid=2ca411c4-b454-492d-8771-226c99d3d33c",

		appName: "Tradetraks",
		appNameProper: "Tradetraks",

		environment: "",
		tokenExpiry: null,
		
		latestPosition: null,
		timeNow: null,
		clockinTime: null,
		clockedIn: false,
		clockedInJob: false, //will be set to an object
		sessionTimer: null,
		tableListMobileBreakpoint: 800,
		messagePanelBreakpoint: 1200,
		mainAreaOffset: 0,
		lastRoute: "", //used for back navigation when could be coming from multiple places

		accountSetupMode: false, //triggers the onboarding wizard
		companySetupMode: false,
		onboardingTips: {
			clockIn: false,
			logExpense: false,
			messages: false
		},

		userRole: "N/A",
		userModulePerms: {},
		userSlug: "",
		userDetails: {},
		sessionToken: "",
		sessionTokenExpiry: "",
		userProjectIds: [],
		userServiceIds: [],
		
		/* MESSAGING*/
		threadsWithNewMessages: [], //list of ids of threads with new messages
		unreadMessageThreads: [], //actual thread objects with unread messages
		checkingMessages: false,
		threadList: [],
		jobsWithThreads: [],
		threadOpenComponentOpen: false,
		lastMessageFetch: "0000-00-00",
		profileImages: [],

		currentMessagePollingInterval: 60000,
		messagePollingTimer: null,
		userActiveTimer: null,
		
		oneSignalRegistered: false,
		oneSignalDeviceId: false,
		oneSignalInitialized: false,

		activeThread: null,

		/* NOTIFICATIONS*/
		recentNotifications: [],
		maxRecentNotifications: 10,
		numTimeLogsToReview: 0,
		numExpensesToReview: 0,
		notificationPollingTimer: null,
		lastReleaseNoteDate: null,

		/* EMPLOYEES / USERS */
		employees: [],
		employee: {},
		profileImage: null,
		profileImageUrl: "",
		users: [],

		unions: [],

		employeeClassifications: [],
		payBoosts: [],

		paginationStates: {}, //a hash map of route: pageNum

		/* CONTACTS */
		contact: {},
		customers: [],
		suppliers: [],
		customerOptions: [],
		contactsIndividuals: [],
		contactFields: [
			{label: "Project Role",key: "role"},
			{label: "Name",key: "name"},
			{label: "Phone",key: "phone",type:'external-link'},
			{label: "Email",key: "email",type:'external-link'},
			{label: "Company",key: "company"}
		],
		customerAsset: {},

		/* PROJECTS / SERVICES */
		project: {
			address: null,
			city: null,
			province: null,
			country: null,
			postal_code: null
		},
		projectUnionCollectiveAgreements: {},
		projectMileageZones: {},
		projects: [],
		lastListedProjects: [],
		relevantProjects: [],
		lastProjectFilters: "",
		projectFilterArchiveValue: 'relevant',
		projectFilterYearValue: 'all',
		jobOpenTimelogs: [],
		invoices: [], //generic invoices list

		/* BIDDING */
		projectBidObjects: [],
		bidComponentsFlat: [],

		fileTags: [],

		jobPersonnelRoles: [],

		service: {},
		services: [],
		serviceWorkOrders: [],
		serviceTasks: [],
		workOrder: {},
		materialsUsed: [],
		serviceFilterArchiveValue: 'all',
		serviceFilterYearValue: 'all',
		serviceStatuses: [],
		changeOrderStatuses: [],

		serviceFilteringValues: {
			customer_id: null,
			contact_location_id: null,
			assigned_to: null,
			category_id: null,
			revenue_code_id: null,
			jobRangeStart: null,
			jobRangeEnd: null
		},
		servicePanelToggled: false,

		serviceContract: {},
		serviceTasks: [],

		categories: [],
		revenueCodes: [],

		/* EXPENSES */
		expenseGroups: [],
		expenseCodes: [],
		expenseHistorySelectedYear: new Date(moment()).getFullYear(),
		expenseHistorySelectedType: 'personal',
		expenseHistoryPeriods: [],
		expenseHistoryFetchedYear: null, //keep track of last year that was fetched, so we don't need to keep pulling it

		/* EQUIPMENT */
		equipments: [],
		equipmentItem: {},
		equipmentTypes: [],
		equipmentCategories: [],

		/* MATERIAL */
		unitMeasurementOptions: [],

		/* COMPANY FORMS */
		companyFormTemplateCategories: [],

		/* SCHEDULE */
		scheduleEvents: [],

		/* QBO */
		qboUserCreditCardSettings: [],
		qboCreditCardAccounts: [],

		payBoostOptions: [],
		collectiveAgreements: [],
		collectiveAgreementOptions: [],

		timeLogSettings: {},

		company: {},
		companyImageUrl: "",
		fetchingSetupStatus: true,

		subscription: {},

		errorList: {},

		printMode: false,
		portalMode: false,

		reportingTabs: [
			{
				label: "Time & Expense",
				icon: "fa-table",
				path: "/reports/time-expenses",
				modulePermRequired: ["Users","Expenses","TimeLogs","Jobs"]
			}
		],

		/*
		calendarLayers: [
			//"expenses",
			//"timeLogs",
			"events",
			"timeOff",
			"equipmentService"
		],
		*/

		mainImageViewerUrl: null,

		certificatesShowShortName: false,
		
		reviewAlertModalShown: false,
		windowWidth: window.innerWidth,

		isUserDrawing: false        // Is the user drawing on the screen?
	}
})